// node_modules
import { FC, useContext } from "react";
// Components
import { SidebarFilterMenu, TitledTypedChild } from "Components";
import { TechnologyPatentDocuments, TechnologyScienceDocuments, TechnologyWebDocuments } from ".";
// Contexts
import { CaseContext, TechnologyContext } from "Stores";
// Style
import styles from "./technologyDocuments.module.scss";

export const TechnologyDocuments: FC = () => {
    // Contexts
    const { caseState } = useContext(CaseContext);
    const { technologyState } = useContext(TechnologyContext);

    return (
        <div className={styles.technologyDocumentsContainer}>
            <SidebarFilterMenu selectedFilterName="science">
                {caseState.isDynamicDelivery|| technologyState.counts.magScienceCount ?
                    <TitledTypedChild title={`Science (${technologyState.counts.magScienceCount})`} typeName="science">
                        <TechnologyScienceDocuments />
                    </TitledTypedChild>
                    : null}
                {caseState.isDynamicDelivery || (technologyState.counts.patentArticleCount + technologyState.counts.magPatentCount > 0) ?
                    <TitledTypedChild title={`Patents (${technologyState.counts.magPatentCount + technologyState.counts.patentArticleCount})`} typeName="patents">
                        <TechnologyPatentDocuments />
                    </TitledTypedChild>
                    : null }
                {caseState.isDynamicDelivery || technologyState.counts.webArticleCount > 0 ?
                    <TitledTypedChild title={`Web (${technologyState.counts.webArticleCount})`} typeName="web">
                        <TechnologyWebDocuments />
                    </TitledTypedChild>
                    : null }
            </SidebarFilterMenu>
        </div>
    );
};